import $ from 'jquery';
import './bootstrap-deps';

class App {

    constructor() {
        $(document).ready(this.ready.bind(this));

        // $( document ).ajaxError(function( event, jqxhr, settings, thrownError ) {
        //     alert("Session expired. You'll be take to the login page");
        //     location.href = "/";
        // });
    }

    /**
     * Method called after document ready.
     */
    ready() {
    }
}

export default new App();
